import { Component, Injector } from '@angular/core';
import { NgControl } from '@angular/forms';

import { CountryDropdownComponentConfigurator } from './country-dropdown-component.configurator';
import { BaseMultiselectDropdownComponent } from '@pl/pl-lib/forms';
import { Country } from 'src/app/core/models/country';

@Component({
  selector: 'app-country-multiselect-dropdown',
  templateUrl:
    '../../../../../../node_modules/@pl/pl-lib/assets/templates/searchable-dropdown/multiselect-dropdown.component.html',
  styleUrls: [
    '../../../../plLibSetup/components/searchable-dropdown/multiselect-dropdown.component.scss'
  ]
})
export class CountryMultiselectDropdownComponent extends BaseMultiselectDropdownComponent<Country> {
  constructor(ngControl: NgControl, injector: Injector) {
    super(ngControl, injector);
    this.configurator = new CountryDropdownComponentConfigurator();
  }
}
